import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + '/v1/admin/';

const buildQueueQuery = ({ sortBy, sortOrder, searchField, searchTerm, statusFilter }) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        const field = searchField || 'receiver';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }
    if (statusFilter) {
        parts.push(`status==${statusFilter}`);
    }
    return parts.join(',');
};

const getAllEmailQueue = (pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildQueueQuery(queryOptions);
    return axios.get(API_URL + 'email-queues', {
        params: { no: pageNo, size: pageSize, q },
    });
};

const getEmailQueueById = (id) => {
    return axios.get(API_URL + 'email-queues/' + id);
};

const getEmailQueuePreview = (id) => {
    return axios.get(API_URL + 'email-queues/' + id + '/preview');
};

const deleteEmailQueue = (data) => {
    return axios.delete(API_URL + 'email-queues', { data });
};

const getAllSmsQueue = (pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildQueueQuery(queryOptions);
    return axios.get(API_URL + 'sms-queues', {
        params: { no: pageNo, size: pageSize, q },
    });
};

const getSmsQueueById = (id) => {
    return axios.get(API_URL + 'sms-queues/' + id);
};

const deleteSmsQueue = (data) => {
    return axios.delete(API_URL + 'sms-queues', { data });
};

const getAllCallQueue = (pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildQueueQuery(queryOptions);
    return axios.get(API_URL + 'call-queues', {
        params: { no: pageNo, size: pageSize, q },
    });
};

const getCallQueueById = (id) => {
    return axios.get(API_URL + 'call-queues/' + id);
};

const deleteCallQueue = (data) => {
    return axios.delete(API_URL + 'call-queues', { data });
};

const processService = {
    getAllEmailQueue,
    getEmailQueueById,
    getEmailQueuePreview,
    deleteEmailQueue,
    getAllSmsQueue,
    getSmsQueueById,
    deleteSmsQueue,
    getAllCallQueue,
    getCallQueueById,
    deleteCallQueue,
};

export default processService;
